import React from 'react';
import styled from 'styled-components';
import { Text } from '../../../../components';
import { COLORS, device, FONTS } from '../../../../constants';

interface DivProps extends React.HTMLProps<HTMLDivElement> {
  teamText: string;
  teamNr: string;
}

export const TeamElement: React.FC<DivProps> = ({
  teamNr,
  teamText,
  ...props
}) => {
  return (
    <ElementStyle {...props}>
      <Text
        size={60}
        weight={400}
        color={COLORS.RED_LINE}
        text={teamNr}
        lineHeight={70}
        fontFamily={FONTS.TITLE}
      />

      <Text
        size={22}
        weight={400}
        color={COLORS.BLACK_TITLE}
        text={teamText}
        wrap="nowrap"
      />
    </ElementStyle>
  );
};

const ElementStyle = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 20px;
  width: 280px;
  box-sizing: border-box;
  border-right: 1px solid #999999;
  &:last-child {
    border-right: none;
  }
  @media screen and ${device.lg} {
    width: 200px;
    padding: 15px;
    box-sizing: border-box;
    > h4:nth-child(2) {
      font-size: 16px;
    }
  }
  @media screen and ${device.md} {
    gap: 0;
    border-right: 0;
    width: 100%;
    border-bottom: 1px solid #999999;
    > h4:nth-child(1) {
      font-size: 30px;
      line-height: 40px;
    }
    > h4:nth-child(2) {
      font-size: 12px;
    }
  }
`;
